const getApiBaseUrl = () => process.env.REACT_APP_URL_PROD;
// process.env.REACT_APP_API_URL || process.env.REACT_APP_URL_PROD;

export const mapPromotionToCarouselCard = (promotion = {}) => {
  const originalPrice =
    promotion.precio ?? promotion.costo ?? promotion.originalPrice ?? 0;
  const finalPrice =
    promotion.total ?? promotion.precio ?? promotion.costo ?? 0;
  const computedDiscount =
    typeof originalPrice === "number" &&
    typeof finalPrice === "number" &&
    originalPrice > 0 &&
    finalPrice > 0
      ? Math.round(((originalPrice - finalPrice) / originalPrice) * 100)
      : 0;

  return {
    id: promotion.id || promotion.nombre || "promo",
    img: promotion.imagen || promotion.img || promotion.image || "",
    title:
      promotion.nombre ||
      promotion.title ||
      promotion.name ||
      "Paquete especial",
    deescrip:
      promotion.descripcion ||
      promotion.deescrip ||
      promotion.description ||
      "Promoción disponible para este mes.",
    precio: originalPrice,
    descuento: promotion.descuento ?? computedDiscount,
    total: finalPrice,
    vigencia: promotion.vigencia,
  };
};

export const getAvailablePromotionsHomeWeb = async () => {
  const baseUrl = getApiBaseUrl();

  if (!baseUrl) {
    return [];
  }

  try {
    const response = await fetch(
      `${baseUrl}/allproducts/getAvailablePromotionsHomeWeb`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    const data = await response.json();

    if (!Array.isArray(data)) {
      return [];
    }

    return data.map(mapPromotionToCarouselCard);
  } catch (error) {
    console.error("No se pudieron cargar las promociones:", error);
    return [];
  }
};
